module.exports = __webpack_public_path__ + "media/images/plans/plan-detail-icon-photo-planning-0d672fc6ff868593ae4044cb4e7c57ed.png";